import { CreateEscrowSettingsApiRow, CreateEscrowSettingsRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

// Used by the Flatfile/CSV upload flow — still accepts the flat tax fields.
export const validateCreateEscrowSettings = makeValidator({
  FieldParser: CreateEscrowSettingsRow,
});

// Used by the public REST API — rejects flat tax fields in favor of the nested address*Tax shape.
export const validateCreateEscrowSettingsApi = makeValidator({
  FieldParser: CreateEscrowSettingsApiRow,
});
